export const HOME_SECTION_DEFAULTS = {
  intro: {
    enabled: true,
    title: 'Helping Women Heal from Breast Implant Illness',
    description: "As a book author and coach, I specialize in supporting women with Breast Implant Illness (BII). My focus is on guiding women through the process of preparing for Explant Surgery and recovering from both BII and the surgery. I'm passionate about helping women heal from all sorts of life and personal health challenges."
  },
  services: {
    enabled: true,
    title: 'How I Can Support You',
    description: 'Comprehensive support throughout your healing journey'
  },
  bookingCard: { enabled: true, title: 'Coaching Sessions', description: 'Personalized one-on-one support tailored to your unique journey and needs.', label: 'Book Now', url: '/booking', newTab: false },
  bookCard: { enabled: true, title: 'My Book', description: 'A comprehensive guide for navigating BII and the explant journey.', label: 'Learn More', url: '/book', newTab: false },
  downloadsCard: { enabled: true, title: 'Free Resources', description: 'Download helpful guides, checklists, and tools for your journey.', label: 'Browse Resources', url: '/downloads', newTab: false },
  communityCard: { enabled: true, title: 'Community Support', description: 'Join a supportive community of women on similar healing journeys.', label: 'Connect', url: '', newTab: true }
};

export function normalizeHomeSections(value) {
  const raw = value && typeof value === 'object' ? value : {};
  return Object.fromEntries(Object.entries(HOME_SECTION_DEFAULTS).map(([key, defaults]) => [key, { ...defaults, ...(raw[key] && typeof raw[key] === 'object' ? raw[key] : {}) }]));
}

export function homeSectionHref(value) {
  const url = typeof value === 'string' ? value.trim() : '';
  if (url.includes('\\')) return '';
  return /^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url) ? url : '';
}
